module.exports = "/dist/montserrat-latin-800italic.svg?93173b4fa0330b6533fffd81129b648c";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800italic.svg
// module id = 81
// module chunks = 0